import { Component, OnInit, ViewChild } from '@angular/core';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { SecurityService } from '../../../services/security/security.service';
import { Router } from '@angular/router';
import { FormGroup } from "@angular/forms";
import { HttpErrorResponse } from '@angular/common/http';
import { MessagesTitles, MessagesStatus } from '../../../models/messages';
import Swal from "sweetalert2";

@Component({
  selector: 'app-listado-guia',
  templateUrl: './listado-guia.component.html',
  styleUrls: ['./listado-guia.component.scss'],
  providers: [MessagesTitles, MessagesStatus]
})
export class ListadoGuiaComponent implements OnInit {

  abrirPopUpGuia: boolean = false;
  abrirPopUpGuiaDetalle: boolean = false;
  form: FormGroup;
  user: any;
  ipAddress: any;
  guiaPadre: any = 0;


  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  pageSizeOptions = [10, 20, 30, 50, 100, 200];
  RepComponentes: any = [];
  loading: boolean = false;
  data: any = {};

  displayedColumns: string[] =
    ['Checked', 'Codigo', 'Descripcion', 'Sistema', 'Estado'];

  dataSource = new MatTableDataSource(this.RepComponentes);

  constructor(private securityService: SecurityService,
    private msgTitulos: MessagesTitles,
    private msgStatus: MessagesStatus,
    private router: Router) {

    this.user = JSON.parse(sessionStorage.getItem('UserActive'));
    this.ipAddress = JSON.parse(sessionStorage.getItem('PUBLIC-IP'));

    this.data.NombreProyecto = 'DigitalFactoring';
    this.data.Usuario = this.user.Usuario;
    this.data.Host = 'INTRANET';
    this.data.IP = this.ipAddress.ip;
    this.data.Canal = 'W';
  }

  ngOnInit() {
    this.ObtenerListaguias();
  }

  ObtenerListaguias() {
    this.loading = true;
    this.securityService.ObtenerListaGuias(this.guiaPadre)
      .subscribe(resp => {
        this.RepComponentes = resp
        this.dataSource = new MatTableDataSource(this.RepComponentes);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        this.pageSizeOptions = [15, 20, 30, 50, 100, 200];
        this.loading = false;
      }, (err: HttpErrorResponse) => {
        this.loading = false;
        if (err.error instanceof ErrorEvent) {
          console.error(err);
        } else {
          this.msgStatus.getMessage(err.status);
        }
        Swal.fire({
          title: this.msgTitulos.Error,
          text: "LISTA GUIAS NO OBTENIDO. " + this.msgStatus.message,
          type: "error",
          allowOutsideClick: false,
          heightAuto: false
        });
      })

  }
  AgregarGuia() {
    this.securityService.dataGuia = '';
    this.abrirPopUpGuia = true;
  }
  VerGuia(elemento: any) {
    this.securityService.dataGuiaDetalle = elemento;
    this.abrirPopUpGuiaDetalle = true;
  }


  EditarGuia(elemento: any) {
    this.securityService.dataGuia = elemento;
    this.abrirPopUpGuia = true;
  }
  EliminarGuia(element: any) {

    this.data.idGuia = element.idGuia;
    this.data.Estado = '0';

    Swal.fire({
      title: '',
      text: '¿Estás seguro de eliminar el id: ' + element.idGuia + '?',
      type: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Si, dar de baja',
      cancelButtonText: 'No, cancelar.',
      reverseButtons: true,
      heightAuto: false
    }).then((result) => {
      if (result.value) {
        this.securityService.ActualizarGuia(this.data)
          .subscribe(res => {
            Swal.fire({
              title: '¡La guia ha sido dada de baja!',
              text: res["message"],
              type: 'success',
              heightAuto: false
            }).then(resp => {
              if (resp.value) {
                this.ngOnInit();
              }
            });

          }, (err: HttpErrorResponse) => {
            if (err.error instanceof ErrorEvent) {
              console.error(err);
            } else {
              this.msgStatus.getMessage(err.status);
            }
            Swal.fire({
              title: this.msgTitulos.Error,
              text: "NO SE ELIMINÓ GUIA. " + this.msgStatus.message,
              type: "error",
              allowOutsideClick: true,
              heightAuto: false
            })
          })
      } else if (result.dismiss === Swal.DismissReason.cancel) {
        this.loading = false;
      }
    })

  }

  CerrarPopUpGuia() {
    this.abrirPopUpGuia = false;
  }
  CerrarPopUpGuiaDetalle() {
    this.abrirPopUpGuiaDetalle = false
  }
  Refresh() {
    this.ngOnInit();
  }

}
